import React, { useEffect, useRef, useCallback, memo } from 'react'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { Col, DatePicker, Form, Input, Row, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import { DATE_FORMAT_LIST, ISO_DATE_FORMAT } from '../../constants'

const { RangePicker } = DatePicker
const { Option } = Select

const AdvanceFilterBlock = props => {
  const { authorityStore, documentStore, loadingAnimationStore } = props
  const { authorityIssuedsList } = authorityStore
  const [form] = Form.useForm()
  const debounceTimerRef = useRef(null)

  const performSearch = useCallback(
    values => {
      const { date_issued } = values

      const filterObj = {
        contruction_board: values.contruction_board?.trim() || undefined,
        document_name: values.document_name?.trim() || undefined,
        document_number: values.document_number?.trim() || undefined,
        from_issue_date: values.from_issue_date,
        to_issue_date: values.to_issue_date,
        status: values.status,
        issue_level: values.issue_level?.trim() || undefined,
        page: 1,
      }

      if (date_issued && date_issued.length === 2) {
        filterObj.from_date_issued = moment(date_issued[0]).format(
          ISO_DATE_FORMAT
        )
        filterObj.to_date_issued = moment(date_issued[1]).format(
          ISO_DATE_FORMAT
        )
      }

      documentStore.setFilterVBPC(filterObj)
    },
    [documentStore]
  )

  const onFormValueChange = useCallback(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current)
    }

    debounceTimerRef.current = setTimeout(() => {
      const values = form.getFieldsValue()
      performSearch(values)
    }, 500)
  }, [form, performSearch])

  useEffect(() => form.resetFields(), [form])

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current)
      }
    }
  }, [])

  return (
    <ContentBlockWrapper>
      <Form
        scrollToFirstError={true}
        form={form}
        layout={'vertical'}
        onValuesChange={onFormValueChange}>
        <Row type={'flex'} gutter={15}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item name={'document_name'} label={'Tên văn bản'}>
              <Input placeholder={'Nhập tên tài liệu'} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              name={'document_number'}
              label={'Số quyết định ban hành'}>
              <Input placeholder={'Nhập số quyết định ban hành'} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label={'Ngày ban hành'} name={'date_issued'}>
              <RangePicker
                format={DATE_FORMAT_LIST}
                style={{ width: '100%' }}
                allowClear
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item name={'issue_level'} label={'Cấp ban hành'}>
              <Input placeholder={'Nhập cấp ban hành'} allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item
              name={'contruction_board'}
              label={'Ban chủ trì xây dựng'}>
              <Input placeholder={'Nhập ban chủ trì xây dựng'} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item name={'status'} label={'Trạng thái'}>
              <Select
                showSearch
                allowClear
                placeholder={'Trạng thái'}
                filterOption={true}
                optionFilterProp={'name'}>
                {['Đã bãi bỏ', 'Hết hiệu lực', 'Còn hiệu lực'].map(
                  (status, index) => {
                    return (
                      <Option key={index} name={status} value={index + 1}>
                        {status}
                      </Option>
                    )
                  }
                )}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </ContentBlockWrapper>
  )
}

AdvanceFilterBlock.propTypes = {}

export default memo(
  inject(
    'authorityStore',
    'documentStore',
    'loadingAnimationStore'
  )(observer(AdvanceFilterBlock))
)
